import React, { useEffect } from "react";
import CMSSocialMediaListing from "./CMSSocialMediaListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
  setIsOpenAddDialog,
  setIsOpenEditDialog,
} from "src/redux/slices/SocialMediaSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import EditSocilMediaWrapper from "../Edit/EditSocilMediaWrapper";
import { useGetCMSByTypeQuery } from "src/services/CMSService";
import AddSocilMediaWrapper from "../Add/AddSocialMediaWrapper";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const CMSSocialMediaListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    issOpenAddDialog,
    isOpenEditDialog,
  } = useSelector((state: RootState) => state.socialMedia);

  const { data, isLoading, isFetching }: any =
    useGetCMSByTypeQuery("SOCIALMEDIA");

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
  }, [data, isLoading, isFetching, dispatch]);

  const moduleName = "CMS";

  const canEdit = usePermission(moduleName, "UPDATE");
  const columns: columnTypes[] = [
    {
      field: "icon",
      headerName: "Icon",
      flex: "flex-[1_1_0%]",
      renderCell: (params) => (
        <img src={params.icon} alt="icon" width={30} height={30} />
      ),
    },
    {
      field: "name",
      headerName: " Name",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "link",
      headerName: " Link",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      align: "center",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              dispatch(setIsOpenEditDialog(true));
            },
          });
        }

        return <ATMMenu options={options} />;
      },
    },
  ];

  return (
    <div>
      <CMSSocialMediaListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenEditDialog && (
        <EditSocilMediaWrapper
          onClose={() => {
            dispatch(setIsOpenEditDialog(false));
          }}
        />
      )}
      {issOpenAddDialog && (
        <AddSocilMediaWrapper
          onClose={() => {
            dispatch(setIsOpenAddDialog(false));
          }}
        />
      )}
    </div>
  );
};

export default CMSSocialMediaListingWrapper;
